import React from 'react';
import styled from '@emotion/styled';
import { useLocale } from 'locale';
import { DeveloperProjectSection } from 'utils/entities';
import { SmallText } from 'ds/components/typography';

const statusToCircleColorMap = {
  [DeveloperProjectSection.Planning]: '#DE6992',
  [DeveloperProjectSection.Building]: '#FFC95E',
  [DeveloperProjectSection.Done]: '#52B1C9',
};

const Wrapper = styled.div`
  ${({ theme }) => `
    box-shadow: ${theme.shadow.level5};
    border-radius: ${theme.borderRadius.small};
    background-color: ${theme.colors.neutrals.white};
    padding: ${theme.spacing(1)} ${theme.spacing(2)};
    z-index: 1;
    position: absolute;
    border: 1px solid ${theme.colors.neutrals.grey8};
  `}
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    left: 24px;
    top: 24px;
  `}
  ${({ theme }) => theme.media.showAt({ to: 2 })`
    right: 16px;
    top: 16px;
  `}
`;
const Item = styled.div`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: space-between;
    &:not(:last-of-type) {
      margin-bottom: ${theme.spacing(1)};
    }
  `}
`;
const Circle = styled.div<{ status: DeveloperProjectSection }>`
${({ theme, status }) => `
    height: 11px;
    width: 11px;
    background-color: ${theme.colors.neutrals.grey1};
    border: 1.5px solid ${statusToCircleColorMap[status]};
    border-radius: ${theme.borderRadius.round};
    margin-right: ${theme.spacing(1)};
  `}
`;

const STATUSES = [ DeveloperProjectSection.Planning, DeveloperProjectSection.Building, DeveloperProjectSection.Done ];

const Legend: React.FC = () => {
  const { t } = useLocale();

  return (
    <Wrapper>
      {STATUSES.map(status => (
        <Item key={status}>
          <SmallText>{t('developerPage.map.legend', { status } )}</SmallText>
          <Circle status={status} />
        </Item>
      ))}
    </Wrapper>
  );
};

export default Legend;
